export interface SmoothlyImageLoader {
    load(url: string): Promise<string>
}
export class DefaultSmoothlyImageLoader implements SmoothlyImageLoader {
    private cache: {[key: string]: string} = {};

    load(imageUrl: string): Promise<string> {
        return this.cache[imageUrl] ? Promise.resolve(this.cache[imageUrl]) : new Promise((next) => {
            const url = imageUrl.startsWith('url') ? imageUrl.slice(4, -1).replace(/"/g, "") : imageUrl;
            const request = new XMLHttpRequest();
            request.responseType = 'arraybuffer';
            request.open('GET', url, true);
            request.onload = () => {
                const uInt8Array = new Uint8Array(request.response);
                let i = uInt8Array.length;
                const biStr = new Array(i);
                while (i--) {
                    biStr[i] = String.fromCharCode(uInt8Array[i]);
                }
                const data = biStr.join('');
                const base64 = window.btoa(data);
                this.cache[imageUrl] = base64;
                next(base64);
            };
            request.send();
        });
    }
}